module.exports = "/_next/static/images/2ab85b72f57e50f2fa437c214492c56b-clips@desktop1024.jpg.webp";